import { createContext, useContext } from 'react'
import type { Database } from '../types/supabase'

export type Organization = Database['public']['Tables']['organizations']['Row']

interface HotelContextType {
  selectedHotel: Organization | null
  availableHotels: Organization[]
  isLoading: boolean
  /** True once an initial hotels fetch has completed (so empty != "still loading"). */
  hasLoadedHotels: boolean
  /** True when the selected hotel is on a paid plan (has an admin or paid owner). */
  selectedHotelIsPremium: boolean
  /** True once the premium status for the selected hotel has been resolved. */
  selectedHotelPremiumResolved: boolean
  selectHotel: (hotel: Organization) => void
  refreshHotels: () => Promise<void>
}

export const HotelContext = createContext<HotelContextType | undefined>(undefined)

export function useHotel() {
  const context = useContext(HotelContext)
  if (context === undefined) {
    throw new Error('useHotel must be used within a HotelProvider')
  }
  return context
}
